export default {
  parseDOM: [{ tag: 'u' }],
  toDOM() {
    return ['u', 0];
  },
};
